module.exports = __webpack_public_path__ + "img/guide02.455c0409.png";